/**
* @prop --uic-list-border: The border of the list
* @prop --uic-list-background: The background of the list
* @prop --uic-list-box-shadow: The shadow of the list
*/

uic-list {
    display: block;
    box-sizing: border-box;
    padding: 0;
    border: var(--uic-list-border);
    background: var(--uic-list-background, white);
    box-shadow: var(--uic-list-box-shadow);
    height: 100%;
}
